import register from "common/bindings/registerBinding";

const res = {widget: {}, textinput: {}};

var tabIndex = function(element, readonly, value) {
    var goToReadonly = readonly ? value : !value;
    if (goToReadonly) {
        if (!element.data("forcedSkipTab")) {
            var i = element.attr("tabindex");
            element.data("indexBackup", i);
        }
        element.attr("tabindex", "-1");
        element.data("forcedSkipTab", true);
    } else {
        var back = element.data("indexBackup");
        var current = element.attr("tabindex");
        if (!!current && current !== "-1") {
            return;
        }
        if (!back) {
            element.removeAttr("tabindex");
        } else {
            element.attr("tabindex", back);
        }
        element.data("forcedSkipTab", false);
    }
};

res.widget.readonly = kendo.data.binders.widget.readonly = kendo.data.Binder.extend({
    refresh: function() {
        var value = this.bindings["readonly"].get();
        if (this.element.wrapper) {
            tabIndex(this.element.wrapper, true, value);
        }
        this.element.readonly(!!value);
    }
});

res.readonly = kendo.data.binders.readonly = kendo.data.Binder.extend({
    refresh: function() {
        var value = this.bindings["readonly"].get();
        if (value) {
            $(this.element).attr("readonly", true).addClass("readonly");
        } else {
            $(this.element).removeAttr("readonly").removeClass("readonly");
        }
        tabIndex($(this.element), true, value);

    }
});

res.widget.editable = kendo.data.binders.widget.editable = kendo.data.Binder.extend({
    refresh: function() {
        var value = this.bindings["editable"].get();
        if (this.element.wrapper) {
            tabIndex(this.element.wrapper, false, !!value);
        }
        this.element.readonly(!value);
    }
});

res.editable = kendo.data.binders.editable = kendo.data.Binder.extend({
    refresh: function() {
        var value = this.bindings["editable"].get();
        if (!value) {
            $(this.element).attr("readonly", true).addClass("readonly");
        } else {
            $(this.element).removeAttr("readonly").removeClass("readonly");
        }
        tabIndex($(this.element), false, !!value);
    }
});

res.textinput.editable = register.widget("textinput", "editable", kendo.data.Binder.extend({
    refresh: function() {
        var value = this.bindings["editable"].get();
        this.element.readonly(!value);
    }
}));
res.textinput.readonly = register.widget("textinput", "readonly", kendo.data.Binder.extend({
    refresh: function() {
        var value = this.bindings["readonly"].get();
        this.element.readonly(!!value);
    }
}));

export default res;
